import React from "react";
import { motion } from "framer-motion";
import { CalendarPlus } from "lucide-react";
import SectionReveal from "./SectionReveal";

// .ics file content for "Add to Calendar"
const ICS = `BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//Fuzail-Fayeza//Wedding//EN
CALSCALE:GREGORIAN
METHOD:PUBLISH
BEGIN:VEVENT
UID:fuzail-fayeza-2026@wedding
DTSTAMP:20260101T000000Z
DTSTART;TZID=America/New_York:20260816T180000
DTEND;TZID=America/New_York:20260816T230000
SUMMARY:Fuzail & Fayeza – Nikah & Walimah
DESCRIPTION:Join us for the Nikah at 6:00 PM followed by the Reception (Walimah) at Victoria Hall.
LOCATION:Victoria Hall\\, 36 Montvale Ave\\, Woburn\\, MA 01801
END:VEVENT
END:VCALENDAR`;

const downloadICS = () => {
  const blob = new Blob([ICS], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "Fuzail-Fayeza-Wedding.ics";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

export default function WeddingDate() {
  return (
    <section
      data-testid="date-section"
      className="relative py-20 px-6 text-center"
    >
      <SectionReveal>
        <p className="uppercase text-[11px] tracking-[0.45em] text-ink/55 mb-4">
          Save the Date
        </p>
      </SectionReveal>

      <SectionReveal delay={0.15}>
        <div className="relative mx-auto max-w-xs">
          <motion.div
            aria-hidden="true"
            initial={{ scale: 0.85, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1.2 }}
            className="absolute inset-0 ink-blob-2 bg-gradient-to-br from-parchment to-champagne/20 blur-[2px]"
          />

          <div className="relative px-8 py-10">
            <div className="flex items-center justify-center gap-6">
              <div className="text-right">
                <p className="font-serif italic text-ink/70 text-lg">Sunday</p>
                <p className="font-serif italic text-ink/50 text-xs mt-1 tracking-widest">
                  AUGUST
                </p>
              </div>

              <div className="relative">
                <div className="w-px h-20 bg-champagne/50" />
              </div>

              <div className="text-left">
                <p
                  className="font-serif italic font-light text-ink leading-none"
                  style={{ fontSize: "5rem" }}
                  data-testid="wedding-day"
                >
                  16
                </p>
              </div>
            </div>

            <div className="mt-4 flex items-center justify-center gap-3">
              <span className="h-px w-10 bg-champagne/50" />
              <p className="font-serif italic text-ink/80 text-lg">2026</p>
              <span className="h-px w-10 bg-champagne/50" />
            </div>

            <p className="mt-6 text-[11px] uppercase tracking-[0.4em] text-ink/55">
              6:00 PM onwards
            </p>
          </div>
        </div>
      </SectionReveal>

      <SectionReveal delay={0.3}>
        <motion.button
          type="button"
          onClick={downloadICS}
          data-testid="add-to-calendar"
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.97 }}
          className="mt-10 inline-flex items-center gap-2.5 text-xs tracking-[0.3em] uppercase text-ink border border-champagne/40 rounded-full px-6 py-3 hover:bg-ink hover:text-cotton hover:border-ink transition-all duration-300 shadow-[0_8px_24px_-12px_rgba(11,21,33,0.25)]"
        >
          <CalendarPlus size={14} strokeWidth={1.6} />
          Add to Calendar
        </motion.button>
      </SectionReveal>
    </section>
  );
}
